import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { Grid2, Typography } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./navbar.css"
import { Image } from '@mui/icons-material';
import primeLogo from "../assets/centerprismLogo.png"
import headerimage from "../assets/headerimage.png"

const navigation = [
  { name: 'Dashboard', href: '#', current: true },
  { name: 'Team', href: '#', current: false },
  { name: 'Projects', href: '#', current: false },
  { name: 'Calendar', href: '#', current: false },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Navbar() {


  return (
    <header>
      <img src={headerimage} id='logoImage' />
      <nav id='top'>
        <ul>
          {/* <img src={primeLogo} id='icon' /> */}
          <div className="text-container">
            <li><h2>Centerprism Survey</h2></li>
            <li><p>Please take a moment to help us serve you.</p></li>
          </div>
        </ul>
      </nav>
    </header>

  )
}
